import { useEffect, useRef } from "react";

interface Listener {
    key: Symbol;
    channel: string;
    onMessage?: (data: any) => void;
}

const listeners: Listener[] = [];

export default function useChannel<T = any>(
    channel: string,
    onMessage?: (data: T) => void
) {
    const listener = useRef({
        key: Symbol(),
        channel,
        onMessage
    });

    listener.current.onMessage = onMessage;

    useEffect(() => {
        listeners.push(listener.current);

        return () => {
            const index = listeners.findIndex(
                value => listener.current === value
            );
            if (index !== -1) listeners.splice(index, 1);
        };
    }, []);

    return {
        send: (data: T) => {
            listeners
                .filter(item => {
                    if (item.channel !== channel) return false; // 不是同一频道的不发
                    return item.key !== listener.current.key; // 消息发送者不发
                })
                .forEach(item => {
                    item.onMessage?.(data);
                });
        }
    };
}
